import { brand, navLinks } from "@/mock";

export const Footer = () => {
  const goTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer
      data-testid="main-footer"
      className="bg-[#0A0A0A] border-t border-white/10 py-14"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={brand.logo}
              alt="Bali Funeral Home"
              className="h-14 w-14 object-contain rounded-md"
            />
            <span className="font-serif text-lg text-[#F5F5F5] tracking-[0.15em]">
              BALI FUNERAL HOME
            </span>
          </div>
          <p className="mt-4 text-sm text-gray-500 leading-relaxed max-w-xs">
            {brand.tagline}
          </p>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Navigimi
          </p>
          <ul className="space-y-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <button
                  onClick={() => goTo(l.href)}
                  className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Kontakt
          </p>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>Shqipëri: {brand.phoneDisplay}</li>
            <li>Itali: {brand.phoneItalyDisplay}</li>
            <li>{brand.email}</li>
            <li>{brand.address}</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-white/5">
        <p className="text-xs text-gray-600">
          © {new Date().getFullYear()} Bali Funeral Home. Të gjitha të drejtat e
          rezervuara.
        </p>
      </div>
    </footer>
  );
};
